export default defineNuxtPlugin(() => {
    // COMPOSABLES
    const { isSessionExpired, sessionExpiredHandler } = useSessionExpiration();
    const {
        public: { frontendBaseUrl: baseURL },
    } = useRuntimeConfig();

    // https://stackoverflow.com/questions/75434573/redefine-fetch-in-nuxt3-with-global-onrequest-handler
    globalThis.$fetch = $fetch.create({
        baseURL,
        onResponseError({ response }) {
            if (isSessionExpired(response._data?.error?.code)) {
                sessionExpiredHandler();
            }
        },
    });
});
